<template>
    <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('systemMessages.systemMessages') }}</span>
        <h3 class="page-title">{{ $t('systemMessages.messagesList') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button theme="success" @click.prevent="$router.push('/ustawienia/komunikaty-systemowe/nowe')">
          <i class="material-icons">add</i>
          {{ $t('systemMessages.addMessage') }}
        </d-button>
      </d-col>
    </d-row>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
    </d-alert>

    <d-card
      v-else
      style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('ui.title') }}</th>
            <th scope="col" class="border-0 text-center">{{ $t('ui.updatedAt') }}</th>
            <th scope="col" class="border-0 text-center" style="width: 125px;">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(message, index) of messages"
            :key="'message-' + index">
            <td class="align-middle">
              {{ message.title }}
            </td>

            <td class="align-middle text-center">
              {{ formatDate(message.updated_at) }}
            </td>

            <td class="align-middle">
              <div class="d-flex justify-center" style="gap: 8px;">
                <d-button
                  theme="primary"
                  @click.native="$router.push('/ustawienia/komunikaty-systemowe/edycja/' + message.id)"
                  :title="$t('ui.edit')">
                  <i class="material-icons">edit</i>
                </d-button>
                <d-button
                  theme="danger"
                  @click.native="removeItem(message.id)"
                  :disabled="!!removeInProgress"
                  :title="$t('ui.delete')">
                  <i class="material-icons">delete</i>
                </d-button>
              </div>
            </td>
          </tr>
          <tr v-if="messages.length === 0">
            <td
              colspan="7"
              class="text-center">
              {{ $t('systemMessages.noMessagesToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="!loaded"
        class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>
    </d-card>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import ListUtils from '@/utils/ListUtils.js';
import CalendarUtils from '@/utils/CalendarUtils';
import HasPagination from '@/mixins/HasPagination.vue';
import Pagination from '@/components/common/Pagination.vue';

export default {
  name: 'system-messages',
  props: {
    isOrderView: {
      default: false,
      type: Boolean
    }
  },
  mixins: [
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data() {
    return {
      messages: [],
      loaded: false,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.loadData();
    }, 250),
    loadData () {
      ListUtils.loadPaginatedItemsData(this, {
        endpoint: '/messages/items?page=' + this.currentPage,
        listField: 'messages',
        method: 'get'
      });
    },
    removeItem (itemID) {
      this.removeInProgress = itemID;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/messages/delete/',
        id: itemID,
        successTitle: this.$t('systemMessages.removeMessageSuccessTitle'),
        successText: this.$t('systemMessages.removeMessageSuccessText'),
        confirmTitle: this.$t('systemMessages.removeMessageConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('systemMessages.removeMessageErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    formatDate (date) {
      if (!date) {
        return '-'
      }

      return CalendarUtils.formatDateForPHP(new Date(date));
    }
  }
};
</script>
